import { ICellRendererParams } from "@ag-grid-community/core";
import { Text } from "@chakra-ui/react";
import React from "react";

export const DataTableChildCount: React.FC<ICellRendererParams> = ({
  node,
}) => {
  const count = node.childrenAfterGroup?.length ?? 0;
  return count > 1 ? (
    <Text as="span" className="mb-group-child-count">
      {count}
    </Text>
  ) : null;
};
